import Vue from 'vue'
import App from './App.vue'
import axios from '@/assets/js/axiosExtend.js'
import VueAxios from 'vue-axios'
import router from './router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/common/common.css'
import '@/assets/css/common/elmentCommon.css'
import i18n from '@/assets/lang/index.js'
import store from './store/index'
import createWS from '@/assets/js/createWS'
import '@/assets/font/iconfont.css'
import '@/assets/font/iconfont'

// import locale from "element-ui/lib/locale/lang/en";
//
// Vue.use(Element, { locale });
// eslint-disable-next-line no-unused-vars
import $ from 'jquery'
import 'tvu-common-ui/lib/style/tvu-common-ui.css'
import {ServiceJumpCollect} from 'tvu-common-ui'
Vue.use(ServiceJumpCollect)
Vue.use(VueAxios, axios)
Vue.use(ElementUI, {
  i18n: (key, val) => i18n.t(key, val) // 用于elementUI插件的中英文翻译
})

Vue.use(createWS)
window.Vue = Vue
Vue.config.productionTip = false
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
